<template>
  <div class="page-legislacao-municipal">
    <div class="centro">
    <div class="titulo-pagina">
      <div class="triangulo-play"></div>
      <h1><span>{{ enteFederativoNome }}</span></h1>
    </div>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cards" />

    </div>
    <div
      class="pesquise"
      v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
    >
      <div class="centro">
        <div>
          <h2>PESQUISE AQUI</h2>
          <div class="linha-input-operadores">
            <div class="item row1">
              <BuscaSimples
                v-model="termo"
                contexto="Digite o número ou texto do ato infralegal"
                @busca-simples="fazerBuscaSimples"
              />
            </div>
            <div class="lado-direito">
              <OperadoresBusca @adicionar-operador="adicionarOperador" />
              <div class="botao">
                <button type="button" @click="tooglePesquisaAvancada">
                  PESQUISA AVANÇADA
                  <span>
                    <template v-if="!exibirPesquisaAvancada">&#9660;</template>
                    <template v-else>&#9650;</template>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <transition name="slide">
            <form v-if="exibirPesquisaAvancada" @submit="fazerBuscaAvancada">
              <div class="avancado">
                <div class="row2">
                  <div class="item">
                    <label>Nº do Ato Infralegal</label>
                    <input type="text" v-model="filtro.numero" />
                  </div>
                  <div class="item">
                    <label>Ano do Ato Infralegal</label>
                    <input type="number" v-model="filtro.ano" />
                  </div>
                </div>
                <div class="row2">
                  <div class="item">
                    <label>Tipo</label>
                    <div v-if="isMobile" class="mobile-multiselect-trigger" @click="abrirTipoMobileDropdown">
                      <span v-if="tiposSelecionados.length === 0">Escolha opções...</span>
                      <span v-else-if="tiposSelecionados.length === 1" class="tipo-nome-unico">{{ tiposSelecionados[0].nome }}</span>
                      <span v-else>{{ tiposSelecionados.length }} selecionados</span>
                    </div>
                    <multiselect
                      v-else
                      v-model="tiposSelecionados"
                      :options="tipos_atos"
                      :multiple="true"
                      :taggable="true"
                      :searchable="true"
                      :show-labels="false"
                      placeholder="Escolha opções..."
                      label="nome"
                      track-by="id"
                    ></multiselect>
                  </div>
                  <div class="item">
                    <label>Órgão Emissor</label>
                    <div v-if="isMobile" class="mobile-multiselect-trigger" @click="abrirOrgaoMobileDropdown">
                      {{ orgaoSelecionado ? orgaoSelecionado.nome : 'Escolha opções...' }}
                    </div>
                    <multiselect
                      v-else
                      v-model="orgaoSelecionado"
                      :options="orgaos_atos"
                      :multiple="false"
                      :taggable="true"
                      :searchable="true"
                      :show-labels="false"
                      placeholder="Escolha opções..."
                      label="nome"
                      track-by="id"
                    ></multiselect>
                  </div>
                </div>
                <div class="row2">
                  <div class="grupo">
                    <p>Data do Ato Infralegal</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_data"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_final_data"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="grupo">
                    <p>Data de início da vigência</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_vigencia_inicio"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_vigencia_fim"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row2">
                  <div class="grupo">
                    <p>Data do fim da vigência</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_final_vigencia_inicio"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_final_vigencia_fim"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label>Texto</label>
                    <input type="text" v-model="filtro.conteudo" />
                  </div>
                </div>
                <div class="row2">
                  <div class="item">
                    <label>Ementa</label>
                    <input type="text" v-model="filtro.ementa" />
                  </div>
                  <div class="item"></div>
                </div>
                <div class="row2">
                  <div class="item"></div>
                  <div class="botoes">
                    <button
                      title="Limpar"
                      @click="limparFiltro()"
                      type="button"
                    >
                      Limpar
                    </button>
                    <button type="submit">Buscar</button>
                  </div>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
    <div class="centro campo-resultados" id="resultados">
      <div class="nav-resultados">
        <div class="first-flex">
          <h2>RESULTADOS DA PESQUISA</h2>
          <div
            class="dados-abertos"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <span>Dados Abertos:</span>
              <a @click="abrirDadosAbertos('json')">JSON</a>
              <a @click="abrirDadosAbertos('csv')">CSV</a>
            </p>
          </div>
        </div>
        <div class="second-flex">
          <ParametrosBusca
            :funcaoBuscaSimples="fazerBuscaSimples"
            :funcaoBuscaAvancada="fazerBuscaAvancada"
            :funcaoRemoveItemFiltro="removerItemFiltro"
            :termo="termo"
            :tipos="tipos_atos"
            :filtro="filtro"
            contexto="ato_infralegal"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          />
          
        </div>
        <div class="third-flex">
          <div
            class="nresultados"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <strong>{{ totalResultadosTexto }}</strong>
              {{ totalResultadosTexto === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
            </p>
          </div>
          <div class="npagina" v-show="!carregando && !carregandoFiltros">
            <label>Resultados por Página</label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <TabelaResultadosAtoInfralegal
          :atosInfralegais="atos"
          :isMunicipal="true"
          :municipioSlug="slug"
          v-if="!carregando && !erro && !carregandoFiltros && !erroFiltros"
        ></TabelaResultadosAtoInfralegal>

        <Loading v-if="carregando || carregandoFiltros" size="medium"></Loading>
        <ErroResultados
          v-if="(!carregando || !carregandoFiltros) && (erro || erroFiltros)"
        ></ErroResultados>

        <paginate
          v-if="!erro && !carregando"
          v-model="pagina"
          :page-count="pageCount"
          :click-handler="mudouPagina"
          :prev-text="'Anterior'"
          :next-text="'Próxima'"
          :container-class="'className'"
          active-class="active-page"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
// Bibliotecas
import { format, parseISO } from "date-fns";
import Paginate from "vuejs-paginate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import Multiselect from "vue-multiselect";

// Componentes
import TabelaResultadosAtoInfralegal from "@/components/pesquisa_ato_infralegal/TabelaResultadosAtoInfralegal.vue";
import Loading from "@/components/Loading";
import ErroResultados from "@/components/ErroResultados";
import ParametrosBusca from "@/components/ParametrosBusca";
import BuscaSimples from "@/components/BuscaSimples.vue";
import OperadoresBusca from "@/components/OperadoresBusca.vue";
import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";

// API, Mixins e helpers
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
import { datepickerFormatter } from "@/helpers/datepickerFormatter";
import tryParseInt from "@/helpers/tryParseInt";

export default {
  name: "AtosInfralegaisPorEnteFederativo",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      enteFederativo: null,
      enteFederativoNome: null,
      atos: [],
      carregando: true,
      erro: false,
      carregandoFiltros: true,
      erroFiltros: false,
      totalResultados: null,
      totalResultadosTexto: null,
      pagina: 1,
      qtd_por_pagina: 10,
      termo: null,
      ordenarPor: null,
      filtro: {
        numero: null,
        conteudo: null,
        tipo_ato_infralegal: null,
        orgao_emissor: null,
        ano: null,
        periodo_inicial_data: null,
        periodo_final_data: null,
        periodo_inicial_vigencia_inicio: null,
        periodo_final_vigencia_inicio: null,
        periodo_inicial_vigencia_fim: null,
        periodo_final_vigencia_fim: null,
        ementa: null,
      },
      tipos_atos: [],
      tiposSelecionados: [],
      orgaos_atos: [],
      orgaoSelecionado: null,
      exibirPesquisaAvancada: tryParseInt(this.getParam("busca_avancada")) == 1,
      datepickerFormatter,
      tiposSelecionadosMobile: [],
      showTipoMobileDropdown: false,
      orgaoSelecionadoMobile: null,
      showOrgaoMobileDropdown: false,
      orgaoFiltroTexto: '',
      isMobile: window.innerWidth < 600,
    };
  },
  components: {
    TabelaResultadosAtoInfralegal,
    Paginate,
    DatePicker,
    Loading,
    ErroResultados,
    ParametrosBusca,
    Multiselect,
    BuscaSimples,
    OperadoresBusca,
    BuscaSimplesCards,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    this.obterEnteFederativo().then(() => {
      this.carregarQtdPorPagina();
      this.carregarValoresFiltro();
      this.carregarAtos();
    });
  },
  mounted() {
      window.addEventListener('resize', this.checkMobile);

      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo("#resultados", 700, {
              offset: -100,
              cancelable: false,
              onDone: () => this.focusResultados(),
            });
          }, 500);
        });
      }
    },
  watch: {
    $route: function (to, from) {
      const mudouQuery =
        to.query.numero != from.query.numero ||
        to.query.conteudo != from.query.conteudo ||
        to.query.tipo_ato_infralegal != from.query.tipo_ato_infralegal ||
        to.query.orgao_emissor != from.query.orgao_emissor ||
        to.query.ementa != from.query.ementa ||
        to.query.ano != from.query.ano ||
        to.query.periodo_inicial_data != from.query.periodo_inicial_data ||
        to.query.periodo_final_data != from.query.periodo_final_data ||
        to.query.periodo_inicial_vigencia_inicio != from.query.periodo_inicial_vigencia_inicio ||
        to.query.periodo_final_vigencia_inicio != from.query.periodo_final_vigencia_inicio ||
        to.query.periodo_inicial_vigencia_fim != from.query.periodo_inicial_vigencia_fim ||
        to.query.periodo_final_vigencia_fim != from.query.periodo_final_vigencia_fim ||
        to.query.pagina != from.query.pagina ||
        to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
        to.query.termo != from.query.termo ||
        to.query.ordenarPor != from.query.ordenarPor;

      if (
        from.name == "AtosInfralegaisPorEnteFederativo" &&
        to.name == "AtosInfralegaisPorEnteFederativo" &&
        mudouQuery
      ) {
        this.carregarValoresFiltro();
        this.carregarAtos();
      }
    },
  },

  methods: {
    removerItemFiltro({ key, id }) {
      const nextQuery = { ...this.$route.query };

      const normalizarArray = (valor) => {
        if (valor === undefined || valor === null || valor === "") {
          return [];
        }
        if (Array.isArray(valor)) {
          return valor.map((item) => item.toString());
        }
        return valor.toString().split(",");
      };

      if (key === "tipo_ato_infralegal" && id !== undefined) {
        const idStr = id.toString();

        this.tiposSelecionados = this.tiposSelecionados.filter(
          (tipo) => tipo.id.toString() !== idStr
        );
        this.tiposSelecionadosMobile = [...this.tiposSelecionados];

        this.filtro.tipo_ato_infralegal = this.tiposSelecionados.map(
          (tipo) => tipo.id
        );

        const valoresAtuais = normalizarArray(nextQuery.tipo_ato_infralegal);
        const atualizados = valoresAtuais.filter((valor) => valor !== idStr);
        if (atualizados.length > 0) {
          nextQuery.tipo_ato_infralegal = atualizados;
        } else {
          delete nextQuery.tipo_ato_infralegal;
        }
      } else if (key === "orgao_emissor") {
        this.orgaoSelecionado = null;
        this.filtro.orgao_emissor = null;
        delete nextQuery.orgao_emissor;
      } else if (key === "ano") {
        this.filtro.ano = null;
        delete nextQuery.ano;
      } else if (key === "periodo_data") {
        this.filtro.periodo_inicial_data = null;
        this.filtro.periodo_final_data = null;
        delete nextQuery.periodo_inicial_data;
        delete nextQuery.periodo_final_data;
      } else if (key === "periodo_inicial_vigencia") {
        this.filtro.periodo_inicial_vigencia_inicio = null;
        this.filtro.periodo_inicial_vigencia_fim = null;
        Object.keys(nextQuery).forEach((queryKey) => {
          if (queryKey.startsWith("periodo_inicial_vigencia")) {
            delete nextQuery[queryKey];
          }
        });
      } else if (key === "periodo_final_vigencia") {
        this.filtro.periodo_final_vigencia_inicio = null;
        this.filtro.periodo_final_vigencia_fim = null;
        Object.keys(nextQuery).forEach((queryKey) => {
          if (queryKey.startsWith("periodo_final_vigencia")) {
            delete nextQuery[queryKey];
          }
        });
      } else {
        if (Array.isArray(this.filtro[key])) {
          this.filtro[key] = [];
        } else if (Object.prototype.hasOwnProperty.call(this.filtro, key)) {
          this.filtro[key] = null;
        }
        delete nextQuery[key];
      }

      const possuiFiltrosAvancados = Object.entries(nextQuery).some(
        ([chave, valor]) => {
          if (
            ["pagina", "qtd_por_pagina", "busca_avancada", "termo"].includes(
              chave
            )
          ) {
            return false;
          }
          if (Array.isArray(valor)) {
            return valor.length > 0;
          }
          return valor !== undefined && valor !== null && valor !== "";
        }
      );

      if (possuiFiltrosAvancados) {
        nextQuery.busca_avancada = 1;
      } else {
        delete nextQuery.busca_avancada;
      }

      this.$router
        .push({
          name: "AtosInfralegaisPorEnteFederativo",
          params: { slug: this.slug },
          query: nextQuery,
        })
        .then(() => {
          this.$scrollTo("#resultados", 700, {
            offset: -100,
            cancelable: false,
          });
        })
        .catch((err) => {
          if (!err || err.name === "NavigationDuplicated") {
            this.$scrollTo("#resultados", 700, {
              offset: -100,
              cancelable: false,
            });
          } else {
            throw err;
          }
        });
    },
    adicionarOperador(operador) {
      if (this.termo == null) {
        this.termo = "";
      }
      this.termo += ` ${operador} `;
    },
    abrirTipoMobileDropdown() {
      this.tiposSelecionadosMobile = [...this.tiposSelecionados];
      this.showTipoMobileDropdown = true;
    },
    closeTipoMobileDropdown() {
      this.showTipoMobileDropdown = false;
      this.tiposSelecionadosMobile = [...this.tiposSelecionados];
    },
    toggleTipoSelecionado(option) {
      const idx = this.tiposSelecionadosMobile.findIndex(sel => sel.id === option.id);
      if (idx === -1) {
        this.tiposSelecionadosMobile.push(option);
      } else {
        this.tiposSelecionadosMobile.splice(idx, 1);
      }
    },
    aplicarTipoSelecionados() {
      this.tiposSelecionados = [...this.tiposSelecionadosMobile];
      this.showTipoMobileDropdown = false;
    },
    abrirOrgaoMobileDropdown() {
      this.orgaoSelecionadoMobile = this.orgaoSelecionado ? { ...this.orgaoSelecionado } : null;
      this.showOrgaoMobileDropdown = true;
      this.orgaoFiltroTexto = '';
    },
    closeOrgaoMobileDropdown() {
      this.showOrgaoMobileDropdown = false;
      this.orgaoFiltroTexto = '';
    },
    selectOrgaoOption(option) {
      this.orgaoSelecionadoMobile = option;
      this.orgaoSelecionado = option;
      this.showOrgaoMobileDropdown = false;
    },

    atualizarOrdenacao(event) {
      this.ordenarPor = event.target.value;
      this.fazerBuscaSimples(this.termo);
    },
    async obterEnteFederativo() {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        this.enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);
        if (!this.enteFederativo) {
          this.erro = true;
          console.error("Ente Federativo não encontrado para o slug: ", this.slug);
        }
      } catch (err) {
        console.error("Erro ao obter Ente Federativo: ", err);
        this.erro = true;
      }
    },
    
    
    mudouQtdPagina: function (event) {
      const novaQtdPagina = parseInt(event.target.value);
      if (novaQtdPagina < this.qtd_por_pagina) {
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(this.pagina);
      } else {
        let novaPagina = Math.ceil(
          (this.qtd_por_pagina * this.pagina) / novaQtdPagina
        );

        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(novaPagina);
      }
    },
    getParam: function (name) {
      if (this.$route && this.$route.query) {
        return this.$route.query[name];
      }
      return null;
    },
    fazerBuscaSimples: function (termo) {
      this.$router.push({
        name: "AtosInfralegaisPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          termo: termo,
          ordenarPor: this.ordenarPor,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
        },
      });

      this.$scrollTo("#resultados", 700, {
        offset: -100,
        cancelable: false,
      });
    },
    fazerBuscaAvancada: function (event) {
      event.preventDefault();

      if (this.tiposSelecionados && this.tiposSelecionados.length > 0) {
        this.filtro.tipo_ato_infralegal = this.tiposSelecionados.map(
          (tipo) => tipo.id
        );
      } else {
        this.filtro.tipo_ato_infralegal = [];
      }

      if (this.orgaoSelecionado) {
        this.filtro.orgao_emissor = this.orgaoSelecionado.id;
      } else {
        this.filtro.orgao_emissor = null;
      }

      this.termo = null;

      this.$router.push({
        name: "AtosInfralegaisPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          ...this.filtro,
          ...this.convertePeriodosDatasParaString(),
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: 1,
        },
      });

      this.$scrollTo("#resultados", 700, {
        offset: -100,
        cancelable: false,
      });
    },
    mudouPagina: function (page) {
      this.pagina = page;
      this.ordenarPor = this.getParam("ordenarPor");
      this.termo = this.getParam("termo");

      const filtro = {
        numero: this.getParam("numero"),
        conteudo: this.getParam("conteudo"),
        tipo_ato: this.getParam("tipo_ato"),
        ementa: this.getParam("ementa"),
        ano: this.getParam("ano"),
        periodo_inicial_ato: this.getParam("periodo_inicial_ato"),
        periodo_final_ato: this.getParam("periodo_final_ato"),
        periodo_inicial_diario: this.getParam("periodo_inicial_diario"),
        periodo_final_diario: this.getParam("periodo_final_diario"),
      };

      this.$router.push({
        name: "AtosInfralegaisPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          ...filtro,
          termo: this.termo,
          pagina: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
          ordenarPor: this.ordenarPor,
          busca_avancada: this.getParam("busca_avancada"),
        },
      });
      this.$scrollTo("#resultados", 0, {
        offset: -100,
        cancelable: false,
      });
    },
    carregarValoresFiltro: async function () {
      try {
        this.carregandoFiltros = true;
        this.erroFiltros = false;

        this.tipos_atos =
          await this.legislacaoApi.getTiposAtosInfralegais(this.enteFederativo.id);
        if (this.filtro.tipo_ato_infralegal) {
          const filtros = Array.isArray(this.filtro.tipo_ato_infralegal)
            ? this.filtro.tipo_ato_infralegal
            : [this.filtro.tipo_ato_infralegal];

          this.tiposSelecionados = this.tipos_atos.filter((tipo) =>
            filtros.some((filtro_tipo) => filtro_tipo == tipo.id)
          );
        } else {
          this.tiposSelecionados = [];
        }

        this.orgaos_atos =
          await this.legislacaoApi.getOrgaosAtosInfralegais(this.enteFederativo.id);
        if (this.filtro.orgao_emissor) {
          this.orgaoSelecionado = this.orgaos_atos.find(
            (o) => o.id == this.filtro.orgao_emissor
          );
        } else {
          this.orgaoSelecionado = null;
        }

        this.carregandoFiltros = false;
      } catch (err) {
        console.log("carregarValoresFiltro", err);
        this.carregandoFiltros = false;
        this.erroFiltros = true;
        this.tipos_atos = [];
        this.orgaos_atos = [];
      }
    },    carregarAtos: async function () {
      try {
        this.carregando = true;
        this.erro = false;

        this.qtd_por_pagina =
          this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

        this.armazenarQtdPorPagina();

        const pagina = this.getParam("pagina") || 1;
        this.pagina = parseInt(pagina);
        this.termo = this.getParam("termo") || "";
        this.ordenarPor = this.getParam("ordenarPor") || "data";

        this.filtro = {
          numero: this.getParam("numero"),
          conteudo: this.getParam("conteudo"),
          tipo_ato_infralegal: this.getParam("tipo_ato_infralegal"),
          orgao_emissor: this.getParam("orgao_emissor"),
          ementa: this.getParam("ementa"),
          ano: this.getParam("ano"),
          ...this.convertPeriodosStringParaDatas(),
        };

        const buscaAvancada = tryParseInt(this.getParam("busca_avancada"));

        if (this.legislacaoApi.cancelTokens.getAtosInfralegaisByEnteFederativo) {
          this.legislacaoApi.cancelTokens.getAtosInfralegaisByEnteFederativo.cancel();
        }

        let data;
        let params = {};

        if (!this.enteFederativo || !this.enteFederativo.id) {
          console.error("ID do Ente Federativo não disponível para carregar atos.");
          this.erro = true;
          this.carregando = false;
          return;
        }

        if (buscaAvancada && buscaAvancada === 1) {
          params = {
            ...this.filtro,
            ...this.convertePeriodosDatasParaString(),
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          };
        } else {
          params = {
            termo: this.termo,
            qtd_por_pagina: this.qtd_por_pagina,
            ordenarPor: this.ordenarPor,
            page: this.pagina,
          };
        }

        data = await this.legislacaoApi.getAtosInfralegaisByEnteFederativo(
          this.enteFederativo.id,
          params
        );

        this.enteFederativoNome = data.ente_federativo.nome;
        this.atos = data.resultados;
        this.totalResultados = data.total_resultados;
        this.totalResultadosTexto = data.total_resultados.toLocaleString("pt-BR");
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log("carregarAtos", err);
        this.carregando = false;
        this.erro = true;
      }
    },
    limparFiltro: function (resetAdvancedSearch = true) {
      this.filtro = {
        numero: null,
        conteudo: null,
        tipo_ato_infralegal: null,
        orgao_emissor: null,
        ementa: null,
        ano: null,
        periodo_inicial_data: null,
        periodo_final_data: null,
        periodo_inicial_vigencia_inicio: null,
        periodo_final_vigencia_inicio: null,
        periodo_inicial_vigencia_fim: null,
        periodo_final_vigencia_fim: null,
      };
      this.tiposSelecionados = [];
      this.termo = null;
      this.orgaoSelecionado = null;
      if (resetAdvancedSearch) {
          this.exibirPesquisaAvancada = false;
      }
    },
    convertePeriodosDatasParaString: function () {
      return {
        periodo_inicial_data: this.filtro.periodo_inicial_data
          ? format(this.filtro.periodo_inicial_data, "yyyy-MM-dd")
          : null,
        periodo_final_data: this.filtro.periodo_final_data
          ? format(this.filtro.periodo_final_data, "yyyy-MM-dd")
          : null,
        periodo_inicial_vigencia_inicio: this.filtro
          .periodo_inicial_vigencia_inicio
          ? format(this.filtro.periodo_inicial_vigencia_inicio, "yyyy-MM-dd")
          : null,
        periodo_final_vigencia_inicio: this.filtro.periodo_final_vigencia_inicio
          ? format(this.filtro.periodo_final_vigencia_inicio, "yyyy-MM-dd")
          : null,
        periodo_inicial_vigencia_fim: this.filtro.periodo_inicial_vigencia_fim
          ? format(this.filtro.periodo_inicial_vigencia_fim, "yyyy-MM-dd")
          : null,
        periodo_final_vigencia_fim: this.filtro.periodo_final_vigencia_fim
          ? format(this.filtro.periodo_final_vigencia_fim, "yyyy-MM-dd")
          : null,
      };
    },
    convertPeriodosStringParaDatas: function () {
      const periodo_inicial_data = this.getParam("periodo_inicial_data");
      const periodo_final_data = this.getParam("periodo_final_data");
      const periodo_inicial_vigencia_inicio = this.getParam(
        "periodo_inicial_vigencia_inicio"
      );
      const periodo_final_vigencia_inicio = this.getParam(
        "periodo_final_vigencia_inicio"
      );
      const periodo_inicial_vigencia_fim = this.getParam(
        "periodo_inicial_vigencia_fim"
      );
      const periodo_final_vigencia_fim = this.getParam(
        "periodo_final_vigencia_fim"
      );

      return {
        periodo_inicial_data: periodo_inicial_data
          ? parseISO(periodo_inicial_data)
          : null,
        periodo_final_data: periodo_final_data
          ? parseISO(periodo_final_data)
          : null,
        periodo_inicial_vigencia_inicio: periodo_inicial_vigencia_inicio
          ? parseISO(periodo_inicial_vigencia_inicio)
          : null,
        periodo_final_vigencia_inicio: periodo_final_vigencia_inicio
          ? parseISO(periodo_final_vigencia_inicio)
          : null,
        periodo_inicial_vigencia_fim: periodo_inicial_vigencia_fim
          ? parseISO(periodo_inicial_vigencia_fim)
          : null,
        periodo_final_vigencia_fim: periodo_final_vigencia_fim
          ? parseISO(periodo_final_vigencia_fim)
          : null,
      };
    },
    abrirDadosAbertos: function (format) {
      if (
        this.totalResultados == undefined ||
        this.totalResultados == null ||
        this.totalResultados > 1000
      ) {
        alert(
          "O download dos dados é limitado a 1000 registros. Refaça sua consulta utilizando os filtros disponíveis."
        );
      } else {
        const params = new URLSearchParams({
          numero: this.getParam("numero") || "",
          conteudo: this.getParam("conteudo") || "",
          tipo_ato_infralegal: this.getParam("tipo_ato_infralegal") || "",
          orgao_emissor: this.getParam("orgao_emissor") || "",
          ementa: this.getParam("ementa") || "",
          ano: this.getParam("ano") || "",
          periodo_inicial_data: this.getParam("periodo_inicial_data") || "",
          periodo_final_data: this.getParam("periodo_final_data") || "",
          periodo_inicial_vigencia_inicio: this.getParam("periodo_inicial_vigencia_inicio") || "",
          periodo_final_vigencia_inicio: this.getParam("periodo_final_vigencia_inicio") || "",
          periodo_inicial_vigencia_fim: this.getParam("periodo_inicial_vigencia_fim") || "",
          periodo_final_vigencia_fim: this.getParam("periodo_final_vigencia_fim") || "",
          termo: this.getParam("termo") || "",
        }).toString();
        window.open(
          `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${this.enteFederativo.id}/dados_abertos_atos_infralegais.${format}?${params}`,
          "_blank"
        );
      }
    },
    tooglePesquisaAvancada: function () {
      this.exibirPesquisaAvancada = !this.exibirPesquisaAvancada;
    },
    armazenarQtdPorPagina() {
      localStorage.setItem("qtd_por_pagina_atos_infralegais", this.qtd_por_pagina);
    },
    carregarQtdPorPagina() {
      const qtd = localStorage.getItem("qtd_por_pagina_atos_infralegais");
      if (qtd) {
        this.qtd_por_pagina = tryParseInt(qtd);
      }
    },
  },
  computed: {
    pageCount: function () {
      if (
        this.totalResultados != undefined &&
        this.totalResultados != null &&
        this.qtd_por_pagina != null &&
        this.qtd_por_pagina != undefined &&
        this.totalResultados > 0 &&
        this.qtd_por_pagina > 0
      ) {
        return Math.ceil(this.totalResultados / this.qtd_por_pagina);
      }
      return 0;
    },
    cards() {
      return [
        {
          rota: { name: "AtosInfralegaisPorEnteFederativoPorTipo", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Ato",
          descricao: "Consulte os Atos Infralegais<br /> por <strong>tipo</strong>",
        },
        {
          rota: { name: "AtosInfralegaisPorEnteFederativoPorOrgao", params: { slug: this.slug } },
          icone: require("@/assets/images/orgao-atos-icon-min2.png"),// Supondo que você tenha um ícone para órgão
          iconeClasse: "legisla-icon",
          titulo: "Órgão",
          descricao: "Consulte os Atos Infralegais<br /> por <strong>órgão</strong>",
        },
        {
          rota: { name: "AtosInfralegaisPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte os Atos Infralegais<br /> por <strong>ano</strong>",
        },
      ];
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.font-black {
  color: black;
  font-weight: bolder;
}
.multiselect-font {
  font-size: 0.9rem;
}
.categoria-nivel-0 {
  font-weight: bolder;
  padding: 0.3rem 0;
  color: black;
}
.categoria-nivel-1 {
  padding-left: 2rem;
  color: rgb(73, 73, 73);
  font-weight: 600;
}
.categoria-nivel-2 {
  padding-left: 4rem;
  color: rgb(78, 78, 78);
  font-weight: 500;
}

.busca-info {
  display: block;
  margin: 0 0 1rem 0;
  padding: 0;
  .info-texto {
    margin: 0.5rem 0;
    color: #ffa900;
    font-size: 0.93rem;
    span {
      font-weight: bold;
    }
  }
}

.header-pesquisa {
  display: flex; /* Habilita o flexbox */
  align-items: center; /* Alinha verticalmente os itens no centro */
  gap: 0.5rem; /* Espaço entre os itens (título e modais) */
  margin-top: 1rem; /* Margem superior para separar de outros elementos */
  margin-bottom: 1rem; /* Margem inferior para separar de outros elementos */

  h2 {
    margin: 0; /* Remove a margem padrão do h2 para melhor controle */
    padding-right: 1rem; /* Mantém o padding à direita do h2 */
    line-height: 1; /* Ajusta a altura da linha para um melhor alinhamento */
  }
}

.tooltip {
  display: flex;
  width: max-content;
  margin: 1rem 0 1rem 0;
  .button {
    margin: 0.3rem 0.7rem 0 0;
    font-size: 0.9rem;
    background-color: #edf2ee;
    border: none;
    border-radius: 0.3rem;
    padding: 0.3rem 0.5rem;
    box-shadow: 1px 2px 1px #ffa900;
    cursor: pointer;
  }
  .button:hover {
    box-shadow: 0px 0px 0px;
    padding: 0.27rem 0.47rem;
    font-size: 0.87rem;
    background-color: #ffa900;
  }
  .container-tooltip {
    position: relative;
  }
  .modal {
    display: block;
    width: 16rem;
    z-index: 1000;
    position: absolute;
    max-width: 20rem;
    font-size: 0.9rem;
    background-color: #edf2ee;
    box-shadow: 3px 5px 5px #ffa900;
    padding: 0.3rem 1rem;
    border-radius: 0.5rem;

    span {
      font-weight: bold;
    }
  }
  .modal-1 {
    display: none;
  }
  .modal-2 {
    display: none;
  }
  .modal-3 {
    display: none;
  }
  .modal-4 {
    display: none;
  }
}

@media screen and (min-width: 320px) and (max-width: 425px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 13%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 31%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 60%;
    }
  }
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 426px) and (max-width: 1024px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 13%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 31%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 60%;
    }
  }
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 20vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 11%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 25%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 50%;
    }
  }
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 25vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1441px) and (max-width: 2560px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 11%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 25%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 50%;
    }
  }
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 15vw;
  }

  .info-field:hover .info-tooltip {
    display: block;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

.titulo-pagina {
  display: flex;
  align-items: center;
  gap: 1rem;
  // margin: 2rem 0rem 1.5rem 0;
}

.centro {
  max-width: 90%;
  margin: 0 auto;
}

.triangulo-play {
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 25px solid #0E489F;
}

h1 span{
  background-color: #ffb24e;
  color: #0E489F;
  margin: 0;
  border-left: #ffa900 solid 0.3rem;
  padding-right: 0.3rem;
  border-radius: 12px;
  line-height: normal;
  width: fit-content;
    -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.pesquise {
  background-color: #115810;
  padding: 0.5rem 1rem 1.5rem;
  /* Linha com input à esquerda e operadores à direita */
  .linha-input-operadores {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    // gap: 1.6rem; /* aproxima input dos botões */
    align-items: start; /* alinha topo dos elementos */
  }
  /* Reduz largura máxima do input para evitar sobreposição */
  .linha-input-operadores .row1 {
    max-width: none; /* permite ocupar toda a coluna */
    width: 100%;
    min-width: 0; /* evita limitar em telas menores */
  }
  .lado-direito {
    display: flex;
    flex-direction: column; /* coloca "Pesquisa avançada" abaixo dos botões */
    align-items: center; /* mantém alinhado à direita do input */
    gap: 0.2rem; /* aproxima o botão dos operadores */
    min-height: 3.2rem;
    margin-top: 0.2rem; /* sobe o bloco inteiro (operadores + pesquisa avançada) */
  }
  .lado-direito .botao {
    margin: 0; /* abaixo, sem margem lateral */
    // margin-top: -0.6rem; /* sobe levemente o botão */
  }
  label {
    color: white;
    font-size: 0.9rem;
  }
  input {
    border: none;
    width: calc(100% - 0.8rem);
    height: 2rem;
    border-radius: 0.2rem;
    border: none;
    padding-left: 0.5rem;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.03rem;
    color: black;
  }
  form {
    .campo-preenchido {
      background-color: #fffed4;
      // border: solid .15rem #ffa900;
      // box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -moz-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -webkit-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
    }
  }

  .botao {
    button {
      background-color: #ffb24e;
      border-radius: 0.2rem;
      border: none;
      font-size: 0.85rem;
      font-family: "Poppins-Bold";
      color: #0e489f;
      height: 1.2rem; /* igual aos operadores */
      padding: 0 0.25rem; /* apenas horizontal */
      margin-top: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 0.03rem;
      // margin-left: 0.25rem;
      span {
        font-size: 0.9rem;
      }
    }
    button:focus {
      box-shadow: none;
      outline: none;
      cursor: pointer;
    }
  }
  .botoes {
    float: right;
    margin: 1rem 0.2rem 1rem auto;
    button {
      margin-left: 1rem;
      padding: 0.1rem 2rem;
      font-family: "Poppins-Medium";
      font-size: 0.9rem;
    }
    button:first-child {
      background: transparent;
      border: white solid 0.15rem;
      color: white;
      padding: 0.1rem 2rem;
      cursor: pointer;
    }
    button:last-child {
      background-color: #ffa900;
      color: #2c3f2b;
      border: solid 0.15rem #ffa900;
      cursor: pointer;
    }
  }

  select {
    width: calc(100% - 0.2rem);
    height: 2rem;
    border: none;
    border-radius: 0.2rem;
    padding-left: 0.5rem;
    background-color: white;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.04rem;
  }

  h2 {
    color: white;
    font-family: "Poppins-Bold";
    font-size: 1.1rem;
    display: inline-table;
    // border-bottom: #ffa900 solid 0.15rem;
    margin: 0rem;
    padding-right: 1rem;
    width: fit-content;
  }
  .row2 {
    display: grid;
    .row2mobile {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      margin-bottom: 4px;
      margin-top: 4px;
    }
  }
  .grupo {
    border: #ffa900 solid 0.15rem;
    margin: 0.5rem 0rem;
    padding: 0.5rem 0.5rem;
    border-radius: 0.5rem;
    .data {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      .mx-datepicker {
        width: 100%;
      }
    }
    p {
      margin: 0rem;
      padding: 0rem;
      color: white;
    }
  }
  .item {
    width: 100%;
    display: grid;
    margin: 0.5rem 0rem;
    height: fit-content;
  }
  .seta {
    img {
      width: 5rem;
      position: absolute;
      right: 1.5rem;
      margin-top: 0rem;
    }
    .t-preto {
      display: none;
    }
  }
}

.campo-resultados {
  margin: 1rem;
  h2 {
    color: #083e07;
    font-size: 1.1rem;
    margin: 1.5rem 0rem 0rem 1rem;
    display: table;
    padding-right: 1rem;
  }
  .dados-abertos {
    width: fit-content;
    margin: 1rem auto 0;
    padding: 0;
    p {
      display: inline-flex;
      align-items: center;
      gap: 1rem;
      margin: 0;
      background-color: #d3d4d3;
      padding: 0.2rem 0.75rem;
      font-size: 0.9rem;
      font-family: "Poppins", sans-serif;
      color: #083e07;
      border-radius: 0.2rem;
      line-height: 1.2;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
      span,
      a {
        margin: 0;
      }
    a {
      text-decoration: none;
      color: #083e07;
      font-family: "Poppins-Medium";
      cursor: pointer;
    }
  }
  .nav-resultados {
    margin: 0 1rem 0 1rem;
    // margin-bottom: 2rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
            color: #083e07;
          }
        }
      }

      .npagina {
        margin: 0;
        text-align: end;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
  .nav-resultados {
    margin-left: 1rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
          }
        }
      }

      .npagina {
        margin: 0;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
}

@media screen and (min-width: 31rem) {
  .nav-resultados {
    margin: 0 0.5rem 2rem 0.5rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 1rem;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 1rem;

      .nresultados {
        margin: 0;

        p {
          font-size: 0.9rem;
          margin: 0rem 0rem -2rem 1rem;
          strong {
            font-family: "Poppins-Medium";
          }
        }
      }

      .npagina {
        margin: 0;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #edf2ee;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
}
@media screen and (min-width: 64rem) {
  h1 {
    margin-left: 0rem;
    font-size: 1.75rem;
  }
  h2 {
    font-size: 1.3rem !important;
  }

  .pesquise {
    padding-bottom: 2rem !important;

    h2 {
      margin-top: 1rem;
      // margin-bottom: 0.5rem;
    }
    .label-busca {
      text-align: left;
      margin-bottom: 0.3rem;
    }
    .row2 {
      grid-template-columns: calc(50% - 1%) calc(50% - 1%);
      gap: 2%;
      .item {
        input {
          padding-right: 0.25rem;
        }
      }
    }
    .grupo {
      padding: 0.5rem 2rem;
    }
    .botoes {
      margin-right: 0rem;
      margin-top: 0.5rem;
      button {
        font-size: 1rem;
        padding: 0.1rem 4rem !important;
        border-radius: 0.2rem;
      }
    }
    .seta {
      img {
        right: 4.7rem;
        margin-top: 0.5rem;
      }
    }
  }
  .campo-resultados {
    // background-color: #efeeed;
    
    h2 {
      font-family: 'Anton', sans-serif;
      font-size: 1.5rem;
      margin-left: 0rem;
      color: #083e07;
    }
    .dados-abertos {
      width: fit-content;
      margin: -2rem 1rem 0rem auto;
      p {
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 0 0.5rem;
        height: 1.2rem;
      }
      span,
      a {
        font-size: 0.8rem;
      }
    }
    .npagina {
      text-align: right;
      label {
        font-size: 0.8rem;
      }
    }
    .nresultados {
      max-width: 17rem;
      text-align: left;
      margin: 0rem 0rem 2rem;
      p {
        font-size: 0.8rem;
        margin: -1.5rem 0rem 0rem 0rem;
        text-align: left;
        strong {
          font-family: "Poppins-Medium";
        }
      }
    }
  }
}

/* Alto Contraste */
.alto-contraste {
  .pesquise {
    background-color: #115810;
    .seta {
      .t-branco {
        display: none;
      }
      .t-preto {
        display: block;
      }
    }
    .botoes {
      button:last-child {
        background-color: #ffa900;
        color: #0d2b10;
        font-family: "Poppins-Medium";
      }
    }
  }
  .nav-resultados {
    h2 {
      color: white;
    }
  }
  .npagina {
    label {
      color: white !important;
    }
  }
  .nresultados {
    color: white;
    
    p {
      color: white !important;
      
      strong {
        color: white !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pesquise {
    .linha-input-operadores {
      grid-template-columns: 1fr; /* empilha em telas pequenas */
    }
    .lado-direito {
      align-items: flex-start;
    }
  }
  .dados-abertos p {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    width: auto;
    min-width: fit-content;
    font-size: 0.7rem !important;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }
}
</style>
